import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import { BadSKUModalProps } from '../../types';
import { API, graphqlOperation } from 'aws-amplify';
import { setBadSKU } from '../TerratreeTable/queries';
import './styles.css';

const BadSKUModal: React.FC<BadSKUModalProps> = ({ open, onClose, data, onSuccess }) => {
  const [selectedBadSKU, setSelectedBadSKU] = useState<string>('');
  const [badSKUBooleanList, setBadSKUBooleanList] = useState<boolean[]>([]);
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (data.item) {
      setBadSKUBooleanList(data.item.badSKU ? JSON.parse(data.item.badSKU) : []);
      if (!data.item.badSKU) {
        setSelectedBadSKU(data.item.sellerSKU[0]);
      } else {
        const firstAvailableIndex = JSON.parse(data.item.badSKU).indexOf(false);
        setSelectedBadSKU(data.item.sellerSKU[firstAvailableIndex]);
      }
    }
  }, [data]);

  const handleConfirm = async () => {
    try {
      if (!selectedBadSKU) return;
      setLoading(true);

      await API.graphql(graphqlOperation(setBadSKU, { delsku: selectedBadSKU.replace(/[\[\]]/g, '') }));

      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setLoading(false);
        if (onSuccess) {
          onSuccess();
        } else {
          onClose();
        }
      }, 1200);
    } catch (error) {
      alert('Failed to set Bad SKU: ' + JSON.stringify(error));
      console.log(error);
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} className="bad-sku-modal">
      <DialogTitle>Confirm bad SKU</DialogTitle>
      <DialogContent>
        <p className="confirmation-text">
          Are you sure you want to mark {selectedBadSKU} as a bad SKU?
        </p>
        <FormControl fullWidth>
          <InputLabel>Select Bad SKU</InputLabel>
          <Select
            value={selectedBadSKU}
            onChange={(e) => setSelectedBadSKU(e.target.value as string)}
            label="Select Bad SKU"
          >
            {data.item?.sellerSKU.map((sku: string, index: number) => (
              <MenuItem
                key={sku}
                value={sku}
                disabled={data.item.badSKU ? badSKUBooleanList[index] : false}
              >
                {sku}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          disabled={!selectedBadSKU}
        >
          Confirm
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onClose}
        >
          Cancel
        </Button>
      </DialogActions>

      <Backdrop open={loading} style={{ zIndex: 1300, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
};

export default BadSKUModal;